export const subMenu = () => {
  const menuItems = document.querySelectorAll(
    ".menu-item-has-children > a:first-child"
  );

  const openSubMenu = (menuItem, submenu) => {
    const parentLi = menuItem.parentElement;
    parentLi.classList.add("submenu-open");
    submenu.classList.add("isOpened");

    submenu.style.display = "block";
    const submenuHeight = submenu.scrollHeight;
    submenu.style.height = "0";
    setTimeout(() => {
      submenu.style.height = `${submenuHeight}px`;
    }, 0);

    submenu.addEventListener(
      "transitionend",
      () => {
        submenu.style.height = "";
      },
      { once: true }
    );
  };

  const closeSubMenu = (menuItem, submenu) => {
    const parentLi = menuItem.parentElement;
    submenu.style.height = `${submenu.scrollHeight}px`;
    setTimeout(() => {
      submenu.style.height = "0";
    }, 0);

    submenu.addEventListener(
      "transitionend",
      () => {
        submenu.style.display = "";
        submenu.style.height = "";
      },
      { once: true }
    );

    parentLi.classList.remove("submenu-open");
    submenu.classList.remove("isOpened");
  };

  menuItems.forEach((menuItem) => {
    const submenu = menuItem.nextElementSibling;

    if (submenu && submenu.classList.contains("sub-menu")) {
      menuItem.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isOpen =
          menuItem.parentElement.classList.contains("submenu-open");

        document.querySelectorAll(".submenu-open").forEach((openLi) => {
          if (openLi !== menuItem.parentElement) {
            const openSubmenu = openLi.querySelector(".sub-menu");
            closeSubMenu(openLi.querySelector("a:first-child"), openSubmenu);
          }
        });

        if (!isOpen) {
          openSubMenu(menuItem, submenu);
        } else {
          closeSubMenu(menuItem, submenu);
        }
      });
    }
  });

  document.addEventListener("click", () => {
    document.querySelectorAll(".submenu-open").forEach((openLi) => {
      const openSubmenu = openLi.querySelector(".sub-menu");
      closeSubMenu(openLi.querySelector("a:first-child"), openSubmenu);
    });
  });
};
